package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class LoanPaymentQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    loan_id: String,
    amount: Long,
    date: String,
    account_id: String,
    tx_id: String?,
    note: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-1_137_540_723, arrayOf("loan_payment"), driver, "LoanPayment.sq",
      "selectAll",
      "SELECT loan_payment.id, loan_payment.loan_id, loan_payment.amount, loan_payment.date, loan_payment.account_id, loan_payment.tx_id, loan_payment.note, loan_payment.created_at, loan_payment.updated_at, loan_payment.is_deleted, loan_payment.deleted_at, loan_payment.synced_at FROM loan_payment WHERE is_deleted = 0 ORDER BY loan_id, date, created_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getLong(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5),
      cursor.getString(6),
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10),
      cursor.getLong(11)
    )
  }

  public fun selectAll(): Query<Loan_payment> = selectAll { id, loan_id, amount, date, account_id,
      tx_id, note, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Loan_payment(
      id,
      loan_id,
      amount,
      date,
      account_id,
      tx_id,
      note,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByLoan(loan_id: String, mapper: (
    id: String,
    loan_id: String,
    amount: Long,
    date: String,
    account_id: String,
    tx_id: String?,
    note: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByLoanQuery(loan_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getLong(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5),
      cursor.getString(6),
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10),
      cursor.getLong(11)
    )
  }

  public fun selectByLoan(loan_id: String): Query<Loan_payment> = selectByLoan(loan_id) { id,
      loan_id_, amount, date, account_id, tx_id, note, created_at, updated_at, is_deleted,
      deleted_at, synced_at ->
    Loan_payment(
      id,
      loan_id_,
      amount,
      date,
      account_id,
      tx_id,
      note,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    loan_id: String,
    amount: Long,
    date: String,
    account_id: String,
    tx_id: String?,
    note: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(2_042_716_350, arrayOf("loan_payment"), driver, "LoanPayment.sq",
      "selectDirty",
      "SELECT loan_payment.id, loan_payment.loan_id, loan_payment.amount, loan_payment.date, loan_payment.account_id, loan_payment.tx_id, loan_payment.note, loan_payment.created_at, loan_payment.updated_at, loan_payment.is_deleted, loan_payment.deleted_at, loan_payment.synced_at FROM loan_payment WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getLong(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5),
      cursor.getString(6),
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10),
      cursor.getLong(11)
    )
  }

  public fun selectDirty(): Query<Loan_payment> = selectDirty { id, loan_id, amount, date,
      account_id, tx_id, note, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Loan_payment(
      id,
      loan_id,
      amount,
      date,
      account_id,
      tx_id,
      note,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    loan_id: String,
    amount: Long,
    date: String,
    account_id: String,
    tx_id: String?,
    note: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getLong(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5),
      cursor.getString(6),
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10),
      cursor.getLong(11)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Loan_payment> = selectByIdAnyState(id) { id_,
      loan_id, amount, date, account_id, tx_id, note, created_at, updated_at, is_deleted,
      deleted_at, synced_at ->
    Loan_payment(
      id_,
      loan_id,
      amount,
      date,
      account_id,
      tx_id,
      note,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    loan_id: String,
    amount: Long,
    date: String,
    account_id: String,
    tx_id: String?,
    note: String?,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(2_033_379_633, """
        |INSERT INTO loan_payment(id, loan_id, amount, date, account_id, tx_id, note, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 9) {
          bindString(0, id)
          bindString(1, loan_id)
          bindLong(2, amount)
          bindString(3, date)
          bindString(4, account_id)
          bindString(5, tx_id)
          bindString(6, note)
          bindLong(7, created_at)
          bindLong(8, updated_at)
        }
    notifyQueries(2_033_379_633) { emit ->
      emit("loan_payment")
    }
  }

  public fun updateFromRemote(
    loan_id: String,
    amount: Long,
    date: String,
    account_id: String,
    tx_id: String?,
    note: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_687_220_913,
        """UPDATE loan_payment SET loan_id = ?, amount = ?, date = ?, account_id = ?, tx_id = ?, note = ?, updated_at = ? WHERE id = ?""",
        8) {
          bindString(0, loan_id)
          bindLong(1, amount)
          bindString(2, date)
          bindString(3, account_id)
          bindString(4, tx_id)
          bindString(5, note)
          bindLong(6, updated_at)
          bindString(7, id)
        }
    notifyQueries(1_687_220_913) { emit ->
      emit("loan_payment")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(156_911_853,
        """UPDATE loan_payment SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(156_911_853) { emit ->
      emit("loan_payment")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(2_045_606_678,
        """UPDATE loan_payment SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(2_045_606_678) { emit ->
      emit("loan_payment")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(1_359_805_471,
        """UPDATE loan_payment SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(1_359_805_471) { emit ->
      emit("loan_payment")
    }
  }

  private inner class SelectByLoanQuery<out T : Any>(
    public val loan_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("loan_payment", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("loan_payment", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_143_922_053,
        """SELECT loan_payment.id, loan_payment.loan_id, loan_payment.amount, loan_payment.date, loan_payment.account_id, loan_payment.tx_id, loan_payment.note, loan_payment.created_at, loan_payment.updated_at, loan_payment.is_deleted, loan_payment.deleted_at, loan_payment.synced_at FROM loan_payment WHERE loan_id = ? AND is_deleted = 0 ORDER BY date, created_at""",
        mapper, 1) {
      bindString(0, loan_id)
    }

    override fun toString(): String = "LoanPayment.sq:selectByLoan"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("loan_payment", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("loan_payment", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_960_680_843,
        """SELECT loan_payment.id, loan_payment.loan_id, loan_payment.amount, loan_payment.date, loan_payment.account_id, loan_payment.tx_id, loan_payment.note, loan_payment.created_at, loan_payment.updated_at, loan_payment.is_deleted, loan_payment.deleted_at, loan_payment.synced_at FROM loan_payment WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "LoanPayment.sq:selectByIdAnyState"
  }
}
